/*
  NDI Mega Menu — hover-with-intent panels + cascading drilldown.
  Each [data-ndi-megamenu-trigger="<key>"] drives the [data-ndi-megamenu="<key>"] panel
  (All Products uses the empty key, Brands uses "brands"). Hover/focus the trigger to
  open; a <button> trigger (no destination) also toggles on click for touch. Inside the
  cascade, hovering an L1 row reveals its L2 column and hovering an L2 row reveals its
  L3 column (first branch pre-selected). A panel with a matching
  [data-ndi-megamenu-template] hydrates from it on first open and caches. Vanilla, deferred.
*/
(function () {
  var menus = [];

  function setup(trigger) {
    var key = trigger.getAttribute('data-ndi-megamenu-trigger') || '';
    var panel = document.querySelector('[data-ndi-megamenu="' + key + '"]');
    if (!panel) return;

    var tpl = document.querySelector('[data-ndi-megamenu-template="' + key + '"]');
    var content = panel.querySelector('[data-ndi-megamenu-content]');
    var hydrated = false;
    var cascade = null;
    var openTimer, closeTimer;

    function activateL1(idx) {
      if (!cascade) return;
      cascade.querySelectorAll('[data-mm-l1]').forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-mm-l1') === idx);
      });
      cascade.querySelectorAll('[data-mm-l2-for]').forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-mm-l2-for') === idx);
      });
      // Pre-select this L1's first L2 so the L3 column isn't blank.
      var firstL2 = cascade.querySelector('[data-mm-l2-for="' + idx + '"] [data-mm-l2]');
      if (firstL2) activateL2(firstL2.getAttribute('data-mm-l2'));
      else cascade.querySelectorAll('[data-mm-l3-for]').forEach(function (el) { el.classList.remove('is-active'); });
    }
    function activateL2(key) {
      if (!cascade) return;
      cascade.querySelectorAll('[data-mm-l2]').forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-mm-l2') === key);
      });
      cascade.querySelectorAll('[data-mm-l3-for]').forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-mm-l3-for') === key);
      });
    }

    function hydrate() {
      if (hydrated || !tpl || !content) return;
      content.appendChild(tpl.content.cloneNode(true));
      cascade = content.querySelector('[data-ndi-mm-cascade]');
      if (cascade) {
        // Drilldown: hovering a row activates its level.
        cascade.addEventListener('mouseover', function (e) {
          var l1 = e.target.closest('[data-mm-l1]');
          if (l1) { activateL1(l1.getAttribute('data-mm-l1')); return; }
          var l2 = e.target.closest('[data-mm-l2]');
          if (l2) { activateL2(l2.getAttribute('data-mm-l2')); }
        });
        // Keyboard: focusing a row activates it too.
        cascade.addEventListener('focusin', function (e) {
          var l1 = e.target.closest('[data-mm-l1]');
          if (l1) { activateL1(l1.getAttribute('data-mm-l1')); return; }
          var l2 = e.target.closest('[data-mm-l2]');
          if (l2) { activateL2(l2.getAttribute('data-mm-l2')); }
        });
        activateL1('0'); // default: first branch open
      }
      hydrated = true;
    }

    function isOpen() { return panel.classList.contains('is-open'); }
    function open() {
      clearTimeout(closeTimer);
      // Only one panel at a time — they share the same spot under the nav.
      menus.forEach(function (m) { if (m.panel !== panel) m.close(); });
      hydrate();
      panel.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      panel.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }
    function openSoon() { clearTimeout(closeTimer); openTimer = setTimeout(open, 120); }
    function closeSoon() { clearTimeout(openTimer); closeTimer = setTimeout(close, 220); }

    trigger.addEventListener('mouseenter', openSoon);
    trigger.addEventListener('mouseleave', closeSoon);
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', closeSoon);
    var refocusing = false;
    trigger.addEventListener('focus', function () { if (!refocusing) open(); });
    // Button trigger: tap opens (touch has no hover). Open-only, not a toggle — a mouse
    // click focuses the button first, which already opened it. Outside click / Esc closes.
    if (trigger.tagName === 'BUTTON') trigger.addEventListener('click', open);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !isOpen()) return;
      var inside = panel.contains(document.activeElement);
      close();
      if (inside) {
        // Return focus to the trigger without its focus handler reopening the panel
        // (focus events dispatch synchronously inside .focus()).
        refocusing = true;
        trigger.focus();
        refocusing = false;
      }
    });
    document.addEventListener('focusin', function (e) {
      if (isOpen() && !panel.contains(e.target) && e.target !== trigger) close();
    });
    document.addEventListener('click', function (e) {
      if (isOpen() && !panel.contains(e.target) && !trigger.contains(e.target)) close();
    });

    menus.push({ panel: panel, close: close });
  }

  function init() {
    document.querySelectorAll('[data-ndi-megamenu-trigger]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
